"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumbappResultStepData = exports.DumbappResultEventData = exports.DumbappResultData = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _remeda = require("remeda");
var _chains = require("@blockwell/chains");
var _variables = require("@blockwell/variables");
class DumbappResultStepData {
  constructor(data) {
    (0, _defineProperty2.default)(this, "address", void 0);
    (0, _defineProperty2.default)(this, "network", void 0);
    (0, _defineProperty2.default)(this, "transactionHash", void 0);
    (0, _defineProperty2.default)(this, "ended", void 0);
    (0, _defineProperty2.default)(this, "error", void 0);
    this.address = data.address;
    this.network = data.network;
    this.transactionHash = data.transactionHash;
    this.ended = data.ended;
    this.error = data.error;
  }
  toString() {
    return this.transactionHash;
  }
}
exports.DumbappResultStepData = DumbappResultStepData;
class DumbappResultEventData {
  constructor(event) {
    (0, _defineProperty2.default)(this, "address", void 0);
    (0, _defineProperty2.default)(this, "event", void 0);
    (0, _defineProperty2.default)(this, "timestamp", void 0);
    (0, _defineProperty2.default)(this, "params", void 0);
    this.address = event.address;
    this.event = event.event;
    this.timestamp = event.timestamp;
    this.params = (0, _variables.ethParametersToVarsValues)(event.params);
  }
  toString() {
    return this.event + "(" + Object.values(this.params).join(", ") + ")";
  }
}
exports.DumbappResultEventData = DumbappResultEventData;
class DumbappResultData {
  constructor(sub) {
    (0, _defineProperty2.default)(this, "id", void 0);
    (0, _defineProperty2.default)(this, "from", void 0);
    (0, _defineProperty2.default)(this, "created", void 0);
    (0, _defineProperty2.default)(this, "shortcode", void 0);
    (0, _defineProperty2.default)(this, "args", void 0);
    (0, _defineProperty2.default)(this, "status", void 0);
    (0, _defineProperty2.default)(this, "extras", void 0);
    (0, _defineProperty2.default)(this, "step", void 0);
    (0, _defineProperty2.default)(this, "events", void 0);
    (0, _defineProperty2.default)(this, "explorer", void 0);
    (0, _defineProperty2.default)(this, "pending", void 0);
    (0, _defineProperty2.default)(this, "done", void 0);
    if (sub) {
      this.id = sub.id;
      this.from = sub.from;
      this.created = sub.created;
      this.shortcode = sub.shortcode;
      this.args = sub.args;
      this.extras = (0, _remeda.omit)(sub.extras, ["palette"]);
      let step = sub.steps[sub.steps.length - 1];
      this.step = new DumbappResultStepData(step);
      if (step.transactionHash) {
        this.explorer = (0, _chains.getChain)(step.network).explorerTx(step.transactionHash);
      }
      this.status = sub.status();
      this.pending = sub.pending();
      this.done = !this.pending;
      if (step.events && step.events.length > 0) {
        let events = {};
        this.events = [];
        for (let it of step.events) {
          if (it.event) {
            let data = new DumbappResultEventData(it);
            events[it.event] = data;
            this.events.push(data);
          }
        }
        for (let [key, val] of Object.entries(events)) {
          this[key] = val;
        }
      }
    }
  }
  toString() {
    return this.status;
  }
}
exports.DumbappResultData = DumbappResultData;
//# sourceMappingURL=DumbappResultData.js.map